export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15228.3d845501.jpg";